// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: (action: string, eventName: string, data?: Record<string, any>) => void;
  }
}

export const trackMetaEvent = (eventName: string, data?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, data);
  }
};

// Standard events you might want to track
export const trackPurchase = (value: number, currency: string = 'USD') => {
  trackMetaEvent('Purchase', { value, currency });
};

export const trackLead = () => {
  trackMetaEvent('Lead');
};

export const trackCompleteRegistration = () => {
  trackMetaEvent('CompleteRegistration');
};

export const trackInitiateCheckout = () => {
  trackMetaEvent('InitiateCheckout');
};

// Chatbot-specific tracking events
export const trackChatbotLead = () => {
  trackMetaEvent('Lead', { source: 'ai_chatbot' });
};

export const trackChatbotBooking = () => {
  trackMetaEvent('InitiateCheckout', { source: 'ai_chatbot' });
};
